'use strict';

import { Injectable, Inject } from 'ng-metadata/core';
import { getVid, getBackendSystem, getInstitutionCode } from '../../appConfig/appConfigForward';
import { SearchStateService, ISearchObject } from '../../search/searchState.service';
import { Cheetah } from '../../search/cheetah.service';
import { JwtUtilService } from '../../security/jwtUtil.service';
import { SavedQueryItem, IApiQueryItem } from '../savedQueries/savedQueries.service';
import { UserSessionManagerService } from '../../security/userSessionManager.service';
import { BrowserStorageManagerService } from '../../security/browserStorageManager.service';
import { SearchFieldsService } from '../../search/search.fields.service';
import { AddQueryToSavedSearchesService } from '../../search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service';
import { SavedQueriesService } from '../savedQueries/savedQueries.service';
import { StorageUtil } from "../../infra/storageUtil.service";
import { ConfigurationUtil } from "../../nddUtils/configurationUtil.service";
import { FacetService } from '../../search/facet/facet.service';
import { FilterInstitution } from '../../nddUtils/filterInstitution.service'
import { NewspapersService } from '../../newspapers/newspapers.service';
import { MappingTablesCache } from "../../mappingTablesCache/mappingTablesCache.service";

const he = require('he');
const includes = require('lodash/includes');
const filter = require('lodash/filter');
const uniqBy = require('lodash/uniqBy');
const some = require('lodash/some');
const flatten = require('lodash/flatten');
const join = require('lodash/join');
const endsWith = require('lodash/endsWith');
const trimEnd = require('lodash/trimEnd');
var angular: angular.IAngularStatic = require('angular');

@Injectable()
export class SearchHistoryService {
    totalItems: Array<SavedQueryItem> = [];
    items: Array<SavedQueryItem> = [];//only the displayed items
    numberOfItemsToDisplay: number = 10;
    bulkSize: number = 10;
    private SAVE_USERS_SEARCH_HISTORY_STRING: string = 'Save Users Search History';
    private DISPLAY_USER_SETTINGS: string = 'display_user_settings';
    private GET_URL: string;
    allItems: boolean = false;
    private _saveUsersSearchHistory: boolean = true;
    private vid: string = getVid();
    private _saveSearchByUserSetting: boolean = true;
	private ALLOW_SAVING_SEARCH_HISTORY = 'allowSavingSearchHistory';


    constructor(private cheetahService: Cheetah,
        @Inject('$http') private $http: angular.IHttpService,
        @Inject('$location') private $location: ng.ILocationService,
        @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
        @Inject('restBaseURLs') private restBaseURLs,
        @Inject('$filter') private $filter,
        @Inject('$mdToast') private $mdToast: ng.material.IToastService,
        @Inject('$httpParamSerializer') private $httpParamSerializer: ng.IHttpParamSerializer,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        private filterInstitution: FilterInstitution,
        private addQueryToSavedSearchesService: AddQueryToSavedSearchesService,
        private searchFieldsService: SearchFieldsService,
        private facetService: FacetService,
        private browserStorageManagerService: BrowserStorageManagerService,
        private savedQueriesService: SavedQueriesService,
        private searchStateService: SearchStateService,
        private userSessionManagerService: UserSessionManagerService,
        private jwtUtilService: JwtUtilService,
        private storageUtil: StorageUtil,
        private mtCache: MappingTablesCache,
        private configurationUtil: ConfigurationUtil,
        private newspapersService: NewspapersService) {

        this.GET_URL = restBaseURLs.saveSearchURL;
        this.browserStorageManagerService.cleanOldItemsFromLocalForage();
        let saveUsersSearchHistoryDisabled = this.mtCache.findByProperties(this.mtCache.tables.INSTITUTION_PROPERTIES, { target: 'N', source1: this.SAVE_USERS_SEARCH_HISTORY_STRING }).length > 0; // OTB enabled
        if (saveUsersSearchHistoryDisabled) {
            this._saveUsersSearchHistory = false;
        }

    }
    get saveSearchByUserSetting(): boolean {
        return this._saveSearchByUserSetting;
    }

    set saveSearchByUserSetting(value: boolean) {
        this._saveSearchByUserSetting = value;
    }
    /*
    returns true if the user is logged in
    */
    public isLoggedIn() {
        return this.userSessionManagerService.getUserName() && this.userSessionManagerService.getUserName().length > 0;
    }

    private getItems() {
        return this.items;
    }

    /*
    gets the search history Items, that are stored in the LocalForage
    */
    private getItemsFromLocalForage() {
        let user = this.jwtUtilService.getDecodedToken().user;
        let localForageKey = user + "_SearchHistoryQeuriesKey";
        this.storageUtil.$localForage.getItem(localForageKey).then((data) => { // gets the search history items array from the local forage.
            if (data == null) {
                data = [];
            }
            this.totalItems = data;
            this.items = [];
            this.resetItems();
            //this.items = data;
            return data;
        });
    }

    /*
    gets the search history Items, that are stored in the DB for a logged in user
    */
    private getItemsFromDB() {
        return this.savedQueriesService.makeRequest('get', null, 'GET', '?vid=' + getVid() + '&type=10')  // type=10 is for getting only search history Items, that are stored in the DB for a logged in user 
            .then((data) => {
                if (data == null) {
                    data = [];
                }
                this.totalItems = data.searchesList;
                this.items = [];
                this.resetItems();
                //this.items = data;
                return data;
            }, (reason) => {
                console.log('get searches from DB failed: ', reason);
            });
    }


    /*
    replaces the oldSearchHistoryKey with newSearchHistoryKey of the Search History data in localForage
    to keep the Search History items when user login
    not used currently because they are kept anyway.
    */
    public changeSearchHistorylocalForageKey(olduser) {
        let user = this.jwtUtilService.getDecodedToken().user;
        let oldSearchHistoryKey = olduser + "_SearchHistoryQeuriesKey";
        let newSearchHistoryKey = user + "_SearchHistoryQeuriesKey";
        this.storageUtil.$localForage.getItem(oldSearchHistoryKey).then((data) => { // gets the search history items array from the local forage.
            if (data == null) {
                data = [];
            }
            return this.storageUtil.$localForage.setItem(newSearchHistoryKey, data).then((data) => { // gets the search history items array from the local forage.
                if (!this._saveUsersSearchHistory) {
                    this.getItemsFromLocalForage();
                } else {
                    this.getItemsFromDB();
                }
            });
        });
    }



    /*
    returns the next none displayed bulk of search history items,
    to display them in an infinite scroll
    */
    public nextResults() {
        let itemsToAdd = Math.min(this.bulkSize, this.totalItems.length - this.numberOfItemsToDisplay);//for the the last bulk
        if (itemsToAdd > 0) {
            this.numberOfItemsToDisplay += itemsToAdd;
            this.items = this.totalItems.slice(0, this.numberOfItemsToDisplay);//add to items the next none displayed bulk of search history items
            if (itemsToAdd < this.bulkSize) {
                this.allItems = true;
            }
        }
        else {
            this.allItems = true;
        }
    }

    /*
    returns true if has More not displayed Results
    */
    public hasNextResults() {
        return (!this.allItems && (this.totalItems.length > this.bulkSize));
    }

    /*
     removes the Search History Item which id is searchHistoryItemId
    */
    public removeSearchHistoryItem(searchHistoryItemId) {
        let resultItemsList;
        if (this.isLoggedIn() && this._saveUsersSearchHistory) {// removes the Item from the DB for a logged in user
            resultItemsList = this.savedQueriesService.removeSearch(searchHistoryItemId).then(() => {
                return this.savedQueriesService.makeRequest('get', null, 'GET', '?vid=' + getVid() + '&type=10')  // type=10 is for getting only search history Items, that are stored in the DB for a logged in user 
                    .then((data) => { return data.searchesList; });
            });
        } else {// removes the Item from the local forage for a guest
            let user = this.jwtUtilService.getDecodedToken().user;
            let localForageKey = user + "_SearchHistoryQeuriesKey";
            resultItemsList = this.storageUtil.$localForage.getItem(localForageKey).then((data) => { // gets the search history items array from the local forage.
                if (data == null) {
                    data = [];
                }
                data = data.filter((d) => { return (d.ID !== searchHistoryItemId) });//returns an array with search History Item which ID is searchHistoryItemId, supposed to be one
                return this.storageUtil.$localForage.setItem(localForageKey, data);// updates the items list in localForage. the displayed list is updated in saved queries list directive
            });
        }
        return resultItemsList;
    }

    /*
    removes multiple items that were selected with a checkbox
    */
    public removeSearchHistorySelectedItems() {
        let resultItemsList;
        let checkedItems = this.getCheckedItems();
        let checkedItemsId;
        if (this.isLoggedIn() && this._saveUsersSearchHistory) {
            checkedItemsId = checkedItems.map((c) => { return { 'id': c.ID } });
            this.makeRequest('remove', { 'ids': checkedItemsId }, 'POST', '/remove?vid=' + getVid())
                .then((res) => {
                    this.getItemsFromDB();
                });
        } else {
            checkedItemsId = checkedItems.map((c) => { return c.ID });
            let user = this.jwtUtilService.getDecodedToken().user;
            let localForageKey = user + "_SearchHistoryQeuriesKey";
            resultItemsList = this.storageUtil.$localForage.getItem(localForageKey).then((data) => { // gets the search history items array from the local forage.
                if (data == null) {
                    data = [];
                }
                data = data.filter((d) => { return !(includes(checkedItemsId, d.ID)) });//removes all the search history items that their ID is in checkedItemsId
                return this.storageUtil.$localForage.setItem(localForageKey, data);// stores the search history items back with out the checked ones
            });
        }
        return resultItemsList; // to use in the following 'then'
    }

    /*
    returns the search history items checked with a checkbox
    */
    public getCheckedItems() {
        if (!this.items) {
            return [];
        }
        return this.items.filter((item) => { return item.checked });
    }

    public setItems(_items) {
        return this.items = _items;
    }

    public setTotalItems(_totalItems) {
        return this.totalItems = _totalItems;
    }

    /*
    assign to items, the number of items to display.
    */
    public refreshItems() {
        this.items = this.totalItems.slice(0, this.numberOfItemsToDisplay);
    }

    /*
    assign to items, the bulk size number of items to display.
    */
    public resetItems() {
        this.allItems = false;
        this.numberOfItemsToDisplay = this.bulkSize;
        this.items = this.totalItems.slice(0, this.numberOfItemsToDisplay);
    }

    /*
    saves the Search History Item which ID is searchHistoryItemId, To Saved Searches.
    then pops a toast which asks the user if he wants to add a mail alert to this query
    */
    public saveSearchHistoryItemToSavedSearches(searchHistoryItemId) {
        let searchHistoryItem = this.getSearchHistoryItemByItemID(searchHistoryItemId);
        let payload = this.calculatePayload([searchHistoryItem]);//must receive an array
        let typeParam = (this._saveUsersSearchHistory) ? '&type=0' : '';

        return this.makeRequest('add', payload, 'POST', '/add?vid=' + getVid() + typeParam).then((res) => {// sends a request to the saved searches api, to save this query
            let templateString = '<prm-add-alert-toast id="' + res.id + '" add-mode="' + true + '" user-email="' + res.email + '"></prm-add-alert-toast>';

            this.$mdToast.show({//pops a toast which asks the user if he wants to add a mail alert to this query
                hideDelay: 8000,
                position: 'top right',
                template: templateString
            }).then(() => { this.addQueryToSavedSearchesService.onToastClose() });
        }, (reason) => {
            console.log('add failed: ', reason);
        }).then((res) => {
            if (this._saveUsersSearchHistory) {
                this.getItemsFromDB();
            }
            this.savedQueriesService.getItemsFromApi();//reloads the saved searches items list from the DB, in saved searches tab
        });
    }

    /*
    saves the Search History Items that were selected with a checkbox, To Saved Searches.
    a toast which asks the user if he wants to add a mail alert to this query - does not pop up!
    */
    public saveSelectedSearchHistoryItemsToSavedSearches() {
        let selectedSearches = this.getCheckedItems();
        let payload = this.calculatePayload(selectedSearches);
        let typeParam = (this._saveUsersSearchHistory) ? '&type=0' : '';
        return this.makeRequest('add', payload, 'POST', '/add?vid=' + getVid() + typeParam).then((res) => {// sends a request to the saved searches api, to save those queries array
            if (this._saveUsersSearchHistory) {
                this.getItemsFromDB();
            }
            this.savedQueriesService.getItemsFromApi();//reloads the saved searches items list from the DB, in saved searches tab
        });
    }



    /*
    Saves automatically each search performed by a logged in user to saved searches.
    */
    public autoSaveSearchHistoryItemToSavedSearches(searchHistoryItem) {
        let payload = this.calculatePayload([searchHistoryItem]);//must receive an array
        this.makeRequest('add', payload, 'POST', '/add?vid=' + getVid() + '&type=10');
    }

    /*
    removes the Search History Item which ID is searchHistoryItemId, from Saved Searches.
    */
    public removeSearchHistoryItemFromSavedSearches(searchHistoryItemId) {
        let ParallelSavedSearchesItems = this.getParallelSavedSearchesId(searchHistoryItemId);
        let payloadIds = ParallelSavedSearchesItems.map((Item) => { return { 'id': Item.ID } });
        let payload = { 'ids': payloadIds };
        return this.makeRequest('remove', payload, 'POST', '/remove?vid=' + getVid()).then((res) => {
            if (this._saveUsersSearchHistory) {
                this.getItemsFromDB();
            }
            this.savedQueriesService.getItemsFromApi();// reloads the saved searches items list from the DB, in saved searches tab
        });
    }

    /*
    removes the Search History Items that were selected with a checkbox, from Saved Searches.
    */
    public removeSelectedSearchHistoryItemFromSavedSearches() {
        let selectedSearches = this.getCheckedItems();
        let payloadIds = [];
        for (let SearchHistoryItem of selectedSearches) {
            if (this.isSearchHistoryItemInSavedSearches(SearchHistoryItem)) {
                let ParallelSavedSearchesItems = this.getParallelSavedSearchesId(SearchHistoryItem.ID);
                for (let item of ParallelSavedSearchesItems) {
                    payloadIds.push({ 'id': item.ID });
                }
            }
        }
        let payload = { 'ids': uniqBy(payloadIds, 'id') };//validate that the query is saved, otherwise get an error when removed in the api.
        return this.makeRequest('remove', payload, 'POST', '/remove?vid=' + getVid()).then((res) => {
            if (this._saveUsersSearchHistory) {
                this.getItemsFromDB();
            }
            this.savedQueriesService.getItemsFromApi();// reloads the saved searches items list from the DB, in saved searches tab
        });
    }

    /*
    returns the ID of a Saved Searches, with similar data to an search History Item,
    which ID is searchHistoryItemID, based on their facet, pfilter, scope, query.
    */
    public getParallelSavedSearchesId(searchHistoryItemID) {
        let searchHistoryItem = this.getSearchHistoryItemByItemID(searchHistoryItemID);
        let savedQueriesServiceItems = this.savedQueriesService.items;
        //returns an array with all the saved searches items, equal to the search history item,
        //based on facet, pfilter, scope and query
        let deeplinkItems = savedQueriesServiceItems.filter((item) => { return (this.compareSearchHistoryAndSavedQueriesItems(searchHistoryItem, item)) });
        return deeplinkItems;
    }

    /*
    returns the Search History Item which ID is searchHistoryItemId
    */
    public getSearchHistoryItemByItemID(searchHistoryItemId) {
        let searchHistoryItem = this.items.filter((item) => { return (item.ID === searchHistoryItemId) })[0];//get search History Item by item id
        return searchHistoryItem;
    }

    /*
    returns true if Search History Item, which id is searchHistoryItemID,
    is saved in Saved Searches, based on its facet, pfilter, scope, query.
    */
    public isSearchHistoryItemInSavedSearches(SearchHistoryItem) {
        let savedQueriesServiceItems = this.savedQueriesService.items;
        if (savedQueriesServiceItems) {
            let savedParallelQueriesServiceItems = savedQueriesServiceItems.filter((savedQueriesServiceItem) => { return this.compareSearchHistoryAndSavedQueriesItems(SearchHistoryItem, savedQueriesServiceItem) });
            return savedParallelQueriesServiceItems.length > 0;
        }
        return false;
    }

    /*
     compares between a Search History And a Saved Queries Items
    */
    public compareSearchHistoryAndSavedQueriesItems(SearchHistoryItem, savedQueriesItem) {
        let similar = (decodeURI(SearchHistoryItem.facet) === decodeURI(savedQueriesItem.facet))
            && (decodeURI(SearchHistoryItem.pfilter) === decodeURI(savedQueriesItem.pfilter))
            && (decodeURI(SearchHistoryItem.scope) === decodeURI(savedQueriesItem.scope))
            && (decodeURI(SearchHistoryItem.query) === decodeURI(savedQueriesItem.query));
        return similar;
    }

    /*
    replaces in 'str', every instace of 'match' with 'repl'
    */
    public multiReplace(str, match, repl) {
        if (match === repl)
            return str;
        do {
            str = str.replace(match, repl);
        } while (str.indexOf(match) !== -1);
        return str;
    }

    /*
    creates a rest request
    */
    public makeRequest(serviceName: string, params: Object = null, method: string = null, suffixPath: string = '') {

        let httpConfig = {
            method: method,
            url: this.GET_URL + suffixPath,
            params: method === 'GET' ? params : null,
            data: method === 'POST' || method === 'PUT' ? params : null
        };

        return this.$http(httpConfig)
            .then(
                (response) => this.reqSuccess(response.data),
                (error) => this.reqFailure(error, serviceName, params)
            );
    }

    /*
    on a rest request Success
    */
    private reqSuccess(response) {

        return response;
    }

    /*
    on a rest request Failure
    */
    private reqFailure(reason, serviceName, params) {

        throw reason;
    }

    /*
    Following code fixes a bug with mdToast who places "position: relative" on root element but doesn't remove it once it is closed.
    This causes md-dialog to not display correctly.
    */
    public onToastClose() {
        angular.element(document.querySelector("primo-explore")).css('position', '');
    }

    /*
    gets a search History Items Array, and calculate the payload of them,
    to send to the saved searches api, as requested there, in order to save them there.
    */
    calculatePayload(searchHistoryItemsArray) {
        let itemsToAddArray = [];
        let ids = [];
        for (let item of searchHistoryItemsArray) {
            let queryUrl = '';
            queryUrl = item.deepLink;
            queryUrl = this.multiReplace(queryUrl, '+', '%20');
            let cheetahSearchData = item.cheetahSearchData;
            ids.push({ 'id': item.ID })
            itemsToAddArray.push({ 'searchData': cheetahSearchData, 'queryUrl': queryUrl });
        }
        let payload = { 'add': itemsToAddArray, 'ids': ids };
        return payload;
    }
    //****** PRM-46520-User settings: persist search history
     public showUserSetting() {
        return this.mtCache.findByProperties(this.mtCache.tables.INSTITUTION_PROPERTIES, { target: 'true', source1: this.DISPLAY_USER_SETTINGS }).length > 0;
    }
    /*
     creates a search history item of the current search query,
     in to the browser, on the local forage,
     after every search action (of any type).
    */

    public updateSearchHistory() {
        let isSignedIn = this.jwtUtilService.isSignedIn();
        if(this._saveUsersSearchHistory){
            if(isSignedIn){
                let allowSavingSearchHistory =this._saveUsersSearchHistory? this.storageUtil.sessionStorage.getItem(this.ALLOW_SAVING_SEARCH_HISTORY): null;
                if (allowSavingSearchHistory != null) {
                 this.saveSearchByUserSetting = allowSavingSearchHistory === 'false' ? false : true;
            }
        }}
         //creating an SavedQueryItem object, to store in the localForageKey,
        //in order to display it later using prm-search-result-list
        let savedQueryItem = this.createSavedQueryItem()
        if (this.storageUtil.isLocalStorageAvailable) { //if we are in cookie mode don't save the query since it will mess up the requests to the server eventually
            let user = this.jwtUtilService.getDecodedToken().user;
            let localForageKey = user + "_SearchHistoryQeuriesKey";
            this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
                this.browserStorageManagerService.area = data;
                this.browserStorageManagerService.addValueToKeyInLocalForage(localForageKey, savedQueryItem) //adds 'savedQueryItem' to an array, in a key-value pair in the local forage, which key is 'localForageKey'.
             });
        }
        if (this.isLoggedIn() && this._saveUsersSearchHistory && this.saveSearchByUserSetting) {
                 this.autoSaveSearchHistoryItemToSavedSearches(savedQueryItem);
        }
    }

    /*
     creates the Facets List of the current search query
    */
    public getFacetsList() {
        let facetsFromUrl = this.$stateParams['facet'] != undefined ? this.$stateParams['facet'] : [];
        let multiFacetsFromUrl = this.$stateParams['mfacet'] != undefined ? this.$stateParams['mfacet'] : [];
        let facets = undefined;
        if (facetsFromUrl.length > 0 || multiFacetsFromUrl.length > 0) {
            facets = decodeURI(join(flatten([facetsFromUrl, multiFacetsFromUrl]), ';'));// the facets that were received from stateParams as Json strings array, delimited with ';'
        }
        return facets;
    }

    /*
     creates a search history item of the current search query,
    */
    public createSavedQueryItem() {
        let user = this.jwtUtilService.getDecodedToken().user;
        let searchQueryUrl = '';
        let baseUrl = '/primo-explore/';
        if (this.configurationUtil.isSuprima()) {
            baseUrl = '/discovery/';
        }

        searchQueryUrl = this.$location.protocol() + '://' + location.host + baseUrl + 'search?' + this.$httpParamSerializer(this.searchFieldsService.searchParams);
        if (this.newspapersService.isNewspapersSearch()) {
            searchQueryUrl = this.$location.absUrl();
        }
        searchQueryUrl = this.multiReplace(searchQueryUrl, '+', '%20');
        let args = this.searchStateService.getSearchObject(); // the object with all the current search details
        let apiSearchItem: IApiQueryItem = {};// the object interfaces that is used to display saved searches.

        apiSearchItem.alert = false;

        let date = new Date();
        apiSearchItem.ID = parseInt(date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString());

        apiSearchItem.creationDate = ("00" + date.getDate()).slice(-2) + '/'
            + ("00" + (date.getMonth() + 1)).slice(-2) + '/'
            + date.getFullYear() + ' '
            + ("00" + date.getHours()).slice(-2) + ':'
            + ("00" + date.getMinutes()).slice(-2) + ':' //adding '0' when the Minutes is one digit
            + ("00" + date.getSeconds()).slice(-2); //adding '0' when the seconds is one digit

        apiSearchItem.deepLink = searchQueryUrl; // the full URL of the search
        apiSearchItem.email = ''; // According to the FSD, there no need of the user Email
        apiSearchItem.mode = args.mode;
        if (apiSearchItem.mode !== 'advanced') {// when the mode is simple, this.$stateParams['mode'] returns undefined
            apiSearchItem.mode = 'simple';
        }
        apiSearchItem.query = decodeURI(join(flatten([this.$stateParams['query']]), ';'));// the facets that were received from stateParams as Json strings array, delimited with ';'
        if (apiSearchItem.query == "") { //when the query is empty, the the results list must receive undefined facet
            apiSearchItem.query = undefined;
        }
        apiSearchItem.scope = decodeURI(args.scope);
        apiSearchItem.tab = args.tab;
        apiSearchItem.checked = false;// at start, the search query is unchecked

        apiSearchItem.pfilter = decodeURI(join(flatten([this.$stateParams['pfilter']]), ';'));// the pfilters that were received from stateParams as Json strings array, delimited with ';'
        if (apiSearchItem.pfilter == "") {// when the pfilter is empty, the the results list must receive undefined pfilter
            apiSearchItem.pfilter = undefined;
        }

        apiSearchItem.facet = this.getFacetsList();// the facets that were received from stateParams as Json strings array, delimited with ';'

        apiSearchItem.cheetahSearchData = this.cheetahService.searchData;//used in saving the query from search history to saved searches

        let savedQueryItem = new SavedQueryItem(apiSearchItem);
        return savedQueryItem;
    }

    get saveUsersSearchHistory(): boolean {
        return this._saveUsersSearchHistory;
    }

    set saveUsersSearchHistory(value: boolean) {
        this._saveUsersSearchHistory = value;
    }




}




// WEBPACK FOOTER //
// ./src/main/webapp/components/favorites/searchHistory/searchHistory.service.ts